import { assertNever } from "@theprelude/core";
import { MailIcon } from "../icons/mail-icon";
import { ServerIcon } from "../icons/server-icon";
import { UserIcon } from "../icons/user-icon";

export type ResourceType = "endpoint" | "user" | "inbox";

interface ResourceTypeIconProps {
  resourceType: ResourceType;
  className?: string;
}

export const ResourceTypeIcon = ({
  resourceType,
  ...props
}: ResourceTypeIconProps) => {
  switch (resourceType) {
    case "endpoint": {
      return <ServerIcon {...props} />;
    }
    case "user": {
      return <UserIcon {...props} />;
    }
    case "inbox": {
      return <MailIcon {...props} />;
    }
    default: {
      return assertNever(resourceType);
    }
  }
};
